import { useEffect, useState } from "react";
import { useSearchParams } from "react-router";
import SupportTypeComponent from "../../components/applicationComponents/supportType/supportType";

export default function SupportTypePage() {
  const [id, setId] = useState("");
  const [searchParams] = useSearchParams();
  useEffect(() => {
    const idParam = searchParams.get("id");
    setId(idParam ?? "");
  }, []);

  return (
    <>
      <SupportTypeComponent disabled={false} id={id} />
    </>
  );
}
